import { View, Text } from "@src/components";
import { memo, useMemo } from "react";
import { ActivityIndicator } from "react-native";
import { SiteAccessListItem } from "./SiteAccessListItem";
import { useAccessManagement } from "@visioni/a3s-access/app";
import { useCameras } from "@src/features/cameras";
import { buildSiteAccessList } from "../utils";

export const SiteAccessList = memo(() => {
  const { data, isLoading: isAccessLoading } = useAccessManagement();
  const { data: cameras, isLoading: isCamerasLoading } = useCameras();

  // Sites derive from `cameras` even when the access-management call fails —
  // an empty roles shape still surfaces the sites the tenant owns.
  const sites = useMemo(() => buildSiteAccessList(data ?? { users: [], roles: [] }, cameras), [data, cameras]);

  if (isAccessLoading || isCamerasLoading) {
    return <ActivityIndicator style={{ paddingVertical: 20 }} />;
  }

  if (sites.length === 0) {
    return (
      <Text textStyle="sm/regular" color="textMuted" style={{ textAlign: "center", paddingVertical: 20 }}>
        No site found
      </Text>
    );
  }

  return (
    <View gap="md">
      {sites.map((site) => (
        <SiteAccessListItem key={site.id} site={site} />
      ))}
    </View>
  );
});
